import { render, staticRenderFns } from "./ScrollList.vue?vue&type=template&id=2adbbdd2&"
import script from "./ScrollList.vue?vue&type=script&lang=js&"
export * from "./ScrollList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/pp-weberbuero-50965/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2adbbdd2')) {
      api.createRecord('2adbbdd2', component.options)
    } else {
      api.reload('2adbbdd2', component.options)
    }
    module.hot.accept("./ScrollList.vue?vue&type=template&id=2adbbdd2&", function () {
      api.rerender('2adbbdd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/grid/ScrollList.vue"
export default component.exports